import { Campus, InventoryProvider, Maybe } from 'content-service'
import { unique } from 'utils'

const findDefaultCampus = (
  defaultCampusId: Maybe<string> = '',
  campuses: Maybe<Maybe<Campus>[]> | undefined
): Campus | null => {
  let defaultCampus: Campus | null | undefined = null

  if (defaultCampusId && campuses) {
    defaultCampus = campuses.find((campus) => campus?.id === defaultCampusId)
  }

  return defaultCampus?.__typename === 'campus' ? defaultCampus : null
}

const determineRegion = (campuses: Maybe<Maybe<Campus>[] | undefined>): string => {
  const { tag, name: campusName } = (campuses && campuses[0]?.region) || {}
  const isSingleRegionCampus = campuses?.every((item) => item?.region?.tag === tag)

  if (isSingleRegionCampus && campusName) {
    return campusName
  }

  if (!isSingleRegionCampus) {
    return 'Multiple regions'
  }

  return ''
}

const validateProviderDetailProps = (providerDetail: InventoryProvider) => {
  const validProviderDetailProps = {
    id: providerDetail.id || '',
    name: providerDetail.name || '',
    profileImages: providerDetail.profileImages ?? [],
    logoUrl: providerDetail.logoUrl || '',
    linkHref: providerDetail.url || '',
    descriptionHtmlString: providerDetail.description || '',
    numberOfStudents: parseInt(providerDetail.attributes?.NUMBER_OF_STUDENTS ?? ''),
    numberOfInternationalStudents: parseInt(
      providerDetail.attributes?.NUMBER_OF_INTERNATIONAL_STUDENTS ?? ''
    ),
    siteUrl: providerDetail.url || '',
    subtype: providerDetail?.subtype?.name ?? '',
    subtypeList: providerDetail?.subtypeList?.map((subtype) => subtype?.tag ?? '') || [''],
    type: providerDetail.type?.tag || '',
    campusRegions: unique(
      providerDetail?.campuses?.map((campus) => campus?.region?.tag ?? '') || ['']
    ),
  }

  return validProviderDetailProps
}

export { validateProviderDetailProps, determineRegion, findDefaultCampus }
